import { useContext, useMemo } from 'react';
import { IM_EXTRACTION_STATUS } from 'models/Listing';
import { getFileNameWithoutExtension } from 'utils';
import ListingContext from '../providers/Listing/Listing.context';
import EditListingContext from '../subrouters/EditListingSubrouter/providers/Listing/Listing.context';

// Whether this listing was drafted by AI from an uploaded IM. A manually created
// listing has no imFileName, so every "AI only" affordance keyed off this stays
// hidden on the manual path without needing to look at the route.
export default function useAiDraftedListing() {
  // The create and edit wizards each have their own listing provider, and a page
  // renders under exactly one of them - the other yields its null default.
  const { listing: createdListing, dealName } = useContext(ListingContext);
  const { listing: editedListing } = useContext(EditListingContext);

  const {
    _id: listingId,
    dealRoomId,
    dealRoom,
    listingTitle,
    imExtractionStatus,
    imFileName,
    imExtractedFields,
  } = createdListing || editedListing || {};

  return useMemo(
    () => ({
      listingId,
      dealRoomId,
      // Only the create provider is handed the deal name; the edit wizard fetches
      // the listing on its own and reads it off the relation.
      dealName: dealName || dealRoom?.name,
      listingName: listingTitle,
      imExtractedFields,
      isAiDrafted:
        imExtractionStatus === IM_EXTRACTION_STATUS.COMPLETED && !!imFileName,
      documentName: getFileNameWithoutExtension(imFileName),
    }),
    [
      listingId,
      dealRoomId,
      dealName,
      dealRoom?.name,
      listingTitle,
      imExtractedFields,
      imExtractionStatus,
      imFileName,
    ],
  );
}
